import { FC } from 'react';
import { MappedAEMProperties } from '../../../types';
import { Role, useSession } from '../../context/SessionContext';
import AuthoringMessage from '../../../components/dev/AuthoringMessage/AuthoringMessage';

const WithAuth = <T extends MappedAEMProperties>(Comp: FC<T>) => {
  return (props: T) => {
    const { payload } = useSession();
    const { isInEditor } = props;

    if (payload?.role === Role.GUEST) {
      return isInEditor ? (
        <AuthoringMessage>
          That component requires authentication and will not be displayed for guest users in the publish instance.
        </AuthoringMessage>
      ) : null;
    }

    return <Comp {...props} />;
  };
};

export default WithAuth;
